import { z } from 'zod'

export const personaSchema = z.object({
  name: z.string().min(2, 'personas.errors.name_min').max(100),
  description: z.string().max(500, 'personas.errors.description_max').optional(),
  tone: z.enum(['encouraging', 'strict', 'playful', 'neutral'], { error: 'personas.errors.tone_required' }),
  pedagogy_style: z.enum(['socratic', 'direct', 'collaborative', 'adaptive'], { error: 'personas.errors.style_required' }),
})

export type PersonaFormData = z.infer<typeof personaSchema>

export type ToneType = PersonaFormData['tone']
export type PedagogyStyleType = PersonaFormData['pedagogy_style']

export interface Persona {
  id: string
  name: string
  description?: string
  tone: ToneType
  pedagogy_style: PedagogyStyleType
  is_default: boolean
  created_at: string
}
